import { z } from 'zod';

export const buildSchema = z.object({
  REACT_APP_BFA_PASSWORD_RESET_TIMEOUT: z.coerce.number().default(30_000),
  REACT_APP_SOCIAL_LOGIN_REDIRECT_URI: z.string().optional(),
  REACT_APP_SOCIAL_LOGIN_ENABLED_FOR: z.string().optional(),
  REACT_APP_RESET_PASSWORD_TIMEOUT_MINUTES: z.coerce.number().default(10),
  REACT_APP_DEFAULT_CLIENT_ID: z.string(),
  REACT_APP_DEFAULT_REDIRECT_URL: z.string(),
  REACT_APP_LABEL_SERVER_BASE_URL: z.string(),
  REACT_APP_NEW_RELIC_ACCOUNT_ID: z.string(),
  REACT_APP_NEW_RELIC_APPLICATION_ID: z.string(),
  REACT_APP_NEW_RELIC_LICENSE_KEY: z.string(),
  REACT_APP_SERVER_BASE_URL: z.string(),
  // FIXME: omitting the `REACT_APP` prefix to preserve backwards compatibility
  PUBLIC_URL: z.string()
});

export const runtimeSchema = z.object({
  COOKIE_SECRET: z.string(),
  CORS_ALLOWED_ORIGINS: z.string(),
  LOGIN_URL: z.string(),
  MEMBER_EMAIL: z.string(),
  MEMBER_PASSWORD: z.string(),
  PORT: z.string().optional(),
  PUBLIC_URL: z.string()
});

export const envSchema = buildSchema.merge(runtimeSchema);
